import React, { useState, useEffect, useRef } from 'react';
import '../../../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import BackModal from '../../BasicElements/BackModal';
import ConfirmModal from '../../BasicElements/ConfirmModal';
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const AllowanceDetailsUpdate = (props) => {
  //#region React Hooks
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [userName] = useState(cookies.USERNAME);
	const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading....");
  const [hasChanges, setHasChanges] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [userDept, setUserDept] = useState([]);
	const [holidayList, setHolidayList] = useState([]);
	const [dayTypeList, setDayTypeList] = useState([]);
  const [dayType, setDayType] = useState([]);
	const [workLocationList, setWorkLocationList] = useState([]);
  const [workLocation, setWorkLocation] = useState([]);
  const [allowanceTypeList, setAllowanceTypeList] = useState([]);
  const [allowanceType, setAllowanceType] = useState([]);
  const [timeRange, setTimeRange] = useState([null, null]);
  const [startTime, endTime] = timeRange;
  const [amount, setAmount] = useState([]);
  const [isFixedTime, setIsFixedTime] = useState(false);
  const [totalHour, setTotalHour] = useState([]);
  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const initialEditData = {
    PURPOSE: "",
    DETAILS: ""
  };

  useEffect(() => {
    if (props.editData !== null) {
      setEditData({
        ALLOWANCE_MST_ID: props.editData.ALLOWANCE_MST_ID === null ? "" : props.editData.ALLOWANCE_MST_ID,
        ALLOWANCE_DETAILS_ID: props.editData.ALLOWANCE_DETAILS_ID === null ? "" : props.editData.ALLOWANCE_DETAILS_ID,
        DATE: props.editData.DATE === null ? "" : props.editData.DATE,
        DAY_TYPE_ID: props.editData.DAY_TYPE_ID === null ? "" : props.editData.DAY_TYPE_ID,
        DAY_TYPE: props.editData.DAY_TYPE === null ? "" : props.editData.DAY_TYPE,
        WORK_LOCATION_ID: props.editData.WORK_LOCATION_ID === null ? "" : props.editData.WORK_LOCATION_ID,
        WORK_LOCATION: props.editData.WORK_LOCATION === null ? "" : props.editData.WORK_LOCATION,
        ALLOWANCE_TYPE_ID: props.editData.ALLOWANCE_TYPE_ID === null ? "" : props.editData.ALLOWANCE_TYPE_ID,
        ALLOWANCE_TYPE: props.editData.ALLOWANCE_TYPE === null ? "" : props.editData.ALLOWANCE_TYPE,
        WORK_TYPE: props.editData.WORK_TYPE === null ? "" : props.editData.WORK_TYPE,
        START_TIME: props.editData.START_TIME === null ? "" : props.editData.START_TIME,
        END_TIME: props.editData.END_TIME === null ? "" : props.editData.END_TIME,
        AMOUNT: props.editData.AMOUNT === null ? "" : props.editData.AMOUNT,
        PURPOSE: props.editData.PURPOSE === null ? "" : props.editData.PURPOSE,
        DETAILS: props.editData.DETAILS === null ? "" : props.editData.DETAILS,
      })
      const start = props.editData.START_TIME ? new Date(`1970-01-01T${props.editData.START_TIME}`) : null;
      const end = props.editData.END_TIME ? new Date(`1970-01-01T${props.editData.END_TIME}`) : null;
      setTimeRange([start, end]);
    }
  }, [props.editData]);
  //#endregion

  //#region useEffect
  useEffect(() => {
      let functionName = "";
      try {
        functionName = "Get User Dept";
        setLoading(true);
        setLoadingText("Getting User Dept, please wait...");
    
        http
          .get("api/allowance/GetUserDept?_sysUser=" + userId, { timeout: 10000 })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].DEPT_ID,
                value: response.data[i].DEPT_NAME,
                label: response.data[i].DEPT_NAME,
              });
            }
            setUserDept(listItems[0]);
          })
          .catch((err) => {
            toast.error("Error on getting user dept. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
        } catch (err) {
          toast.error("Error on getting user dept. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        }
    }, [userId]);
      
    useEffect(() => {
      let functionName = "";
      
      try {
        functionName = "Get Holiday List";
        setLoading(true);
        setLoadingText("Getting Holiday List, please wait...");
      
        http
          .get("api/allowance/GetHolidayList?_sysUser=" + userId, { timeout: 10000 })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].HOLIDAY_ID,
                value: response.data[i].HOLIDAY_DATE,
                label: response.data[i].HOLIDAY_NAME,
              });
            }
            setHolidayList(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting holiday list. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
        } catch (err) {
          toast.error("Error on getting holiday list. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        }
    }, [userId]);
  
    useEffect(() => {
      let functionName = "";

      if (!userDept.key) return;

      try {
        functionName = "Get Day Type List";
        setLoading(true);
        setLoadingText("Getting Day Type List, please wait...");
  
        const deptId = userDept.key;
    
        http
          .get("api/allowance/GetDayTypeList?_sysUser=" + userId +
          "&_deptId=" +
          deptId, { timeout: 10000 })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].DAY_TYPE_ID,
                value: response.data[i].DAY_TYPE_ID,
                label: response.data[i].DAY_TYPE,
              });
            }
            setDayTypeList(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting day type list. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
        } catch (err) {
          toast.error("Error on getting day type list. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        }
    }, [userId, userDept]);
    
    useEffect(() => { 
      if (dayTypeList.length > 0 && props.editData !== null && props.editData.DAY_TYPE_ID) { 
        const matchedDayType = dayTypeList.find(day => day.value === props.editData.DAY_TYPE_ID); 
        if (matchedDayType) { 
          setDayType(matchedDayType); 
        } 
      } 
    }, [dayTypeList, props.editData]);
  
    useEffect(() => {
      let functionName = "";

      if (!userDept.key || !dayType.key) return;

      try {
        functionName = "Get Work Location List";
        setLoading(true);
        setLoadingText("Getting Work Location List, please wait...");
  
        const deptId = userDept.key;
        const dayTypeId = dayType.key;
    
        http
          .get("api/allowance/GetWorkLocationList?_sysUser=" + userId +
          "&_deptId=" +
          deptId +
          "&_dayType=" +
          dayTypeId, { timeout: 10000 })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].WORK_LOCATION_ID,
                value: response.data[i].WORK_LOCATION_ID,
                label: response.data[i].WORK_LOCATION,
              });
            }
            setWorkLocationList(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting work location list. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
        } catch (err) {
          toast.error("Error on getting work location list. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        }
    }, [userId, userDept, dayType]);
    
    useEffect(() => { 
      if (workLocationList.length > 0 && props.editData !== null && props.editData.WORK_LOCATION_ID) { 
        const matchedWorkLocation = workLocationList.find(work => work.value === props.editData.WORK_LOCATION_ID); 
        if (matchedWorkLocation) { 
          setWorkLocation(matchedWorkLocation); 
        } 
      } 
    }, [workLocationList, props.editData]);
    
    useEffect(() => {
      let functionName = "";

      if (!userDept.key || !dayType.key || !workLocation.key) return;

      try {
        functionName = "Get Allowance Type List";
        setLoading(true);
        setLoadingText("Getting Allowance Type List, please wait...");
  
        const deptId = userDept.key;
        const dayTypeId = dayType.key;
        const workLocationId = workLocation.key;
    
        http
          .get("api/allowance/GetAllowanceTypeList?_sysUser=" + userId +
          "&_deptId=" +
          deptId +
          "&_dayType=" +
          dayTypeId +
          "&_workLocation=" +
          workLocationId, { timeout: 10000 })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].ALLOWANCE_TYPE_ID,
                value: response.data[i].ALLOWANCE_TYPE_ID,
                label: response.data[i].ALLOWANCE_TYPE,
              });
            }
            setAllowanceTypeList(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting allowance type list. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
        } catch (err) {
          toast.error("Error on getting allowance type list. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        }
    }, [userId, userDept, dayType, workLocation]);
    
    useEffect(() => { 
      if (allowanceTypeList.length > 0 && props.editData !== null && props.editData.ALLOWANCE_TYPE_ID) { 
        const matchedAllowanceType = allowanceTypeList.find(allowance => allowance.value === props.editData.ALLOWANCE_TYPE_ID); 
        if (matchedAllowanceType) { 
          setAllowanceType(matchedAllowanceType); 
        } 
      } 
    }, [allowanceTypeList, props.editData]);
    
    useEffect(() => {
      let functionName = "";
      try {
        functionName = "Get Amount";
        setLoading(true);
        setLoadingText("Getting Amount, please wait...");

      const formatTime = (date) =>
        date instanceof Date
          ? `${date.getHours().toString().padStart(2, "0")}${date
              .getMinutes()
              .toString()
              .padStart(2, "0")}`
          : date || "";

      const toDate = (time) => {
        if (!time) return null;

        if (time instanceof Date) return time;

        const [h, m] = time.split(":").map(Number);
        return new Date(2000, 0, 1, h, m);
      };

      const getTimeDiff = (start, end) => {
        const startDate = toDate(start);
        const endDate = toDate(end);

        if (!startDate || !endDate) return "0000";

        let diff = endDate - startDate;
        if (diff < 0) {
            diff += 24 * 60 * 60 * 1000;
        }

        const totalMinutes = Math.round(diff / (1000 * 60));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return minutes > 0 ? hours + 1 : hours;
      };
      
      const getActualDuration = (start, end) => {
        const startDate = toDate(start);
        const endDate = toDate(end);

        if (!startDate || !endDate) return "00:00";

        let diff = endDate - startDate;
        if (diff < 0) {
          diff += 24 * 60 * 60 * 1000;
        }

        const totalMinutes = Math.round(diff / (1000 * 60));
        const hh = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
        const mm = String(totalMinutes % 60).padStart(2, "0");

        return `${hh}:${mm}`;
      };
    
        const deptId = userDept.key;
        const DayType = dayType.key;
        const WorkLocation = workLocation.key;
        const AllowanceType = allowanceType.key;
        const StartTime = formatTime(startTime);
        const EndTime = formatTime(endTime);
        const totalTime = getTimeDiff(startTime, endTime);
        const actualDuration = getActualDuration(startTime, endTime);
        setTotalHour(actualDuration);
  
        http
          .get("api/allowance/GetAmount?_sysUser=" + userId +
            "&_deptId=" +
            deptId +
            "&_dayType=" +
            DayType +
            "&_workLocation=" +
            WorkLocation +
            "&_allowanceType=" +
            AllowanceType +
            "&_startTime=" +
            StartTime +
            "&_endTime=" +
            EndTime +
            "&_totalTime=" +
            totalTime, { timeout: 10000 })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].ALLOWANCE_RATE_MST_ID,
                value: response.data[i].AMOUNT,
                label: response.data[i].REMARK,
                HOUR_FROM: response.data[i].HOUR_FROM,
                HOUR_TO: response.data[i].HOUR_TO,
                });

              const item = response.data[i];

              const timeToDate = (time) => {
                if (!time || time === 'N/A') return null;

                if (/^\d{4}$/.test(time)) {
                  const h = Number(time.slice(0, 2));
                  const m = Number(time.slice(2, 4));
                  return isNaN(h) || isNaN(m) ? null : new Date(2000, 0, 1, h, m);
                }

                if (/^\d{2}:\d{2}$/.test(time)) {
                  const [h, m] = time.split(':').map(Number);
                  return isNaN(h) || isNaN(m) ? null : new Date(2000, 0, 1, h, m);
                }

                if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
                  const [h, m] = time.split(':').map(Number);
                  return isNaN(h) || isNaN(m) ? null : new Date(2000, 0, 1, h, m);
                }

                return null;
              };

              const isSameTimeRange = (a, b) =>
                a?.[0]?.getTime?.() === b?.[0]?.getTime?.() &&
                a?.[1]?.getTime?.() === b?.[1]?.getTime?.();

              if(AllowanceType == '459E6A7E-289A-4EB5-B99C-DEE6D6D15153') {
                if (timeToDate(item.HOUR_FROM) && timeToDate(item.HOUR_TO)) {
                  setTimeRange(prev =>
                    isSameTimeRange(
                      prev,
                      [timeToDate(item.HOUR_FROM), timeToDate(item.HOUR_TO)]
                    )
                      ? prev
                      : [timeToDate(item.HOUR_FROM), timeToDate(item.HOUR_TO)]
                  );
                }
                setIsFixedTime(true);
              } else if (item.HOUR_FROM == 'N/A' && item.HOUR_TO == 'N/A') {
                setIsFixedTime(true);
              } else {
                setIsFixedTime(false);
              }
            }
            setAmount(listItems[0]);
          })
          .catch((err) => {
            toast.error("Error on getting amount. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
        } catch (err) {
          toast.error("Error on getting amount. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        }
    }, [userId, userDept, dayType, workLocation, allowanceType, startTime, endTime]);
  //#endregion

  //#region Save Edit
  function saveEditDetails() {
    let functionName = "";

    try {
      functionName = saveEditDetails.name;
      setLoading(true, "Updating allowance details, Please wait....");

      const StartTime = startTime || "00:00";
      const EndTime = endTime || "00:00";

      const toDate = (time) => {
        if (!time) return null;

        if (time instanceof Date) return time;

        const [h, m] = time.split(":").map(Number);
        return new Date(2000, 0, 1, h, m);
      };

      const getTimeDiff = (start, end) => {
        const startDate = toDate(start);
        const endDate = toDate(end);

        if (!startDate || !endDate) return "00:00";

        let diff = endDate - startDate;
        if (diff < 0) {
            diff += 24 * 60 * 60 * 1000;
        }

        const totalMinutes = Math.round(diff / (1000 * 60));
        const hh = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
        const mm = String(totalMinutes % 60).padStart(2, "0");

        return `${hh}:${mm}`;
      };

      const combineDateTime = (dateStr, time) => {
        if (!dateStr || !time) return "";

        const [year, month, day] = dateStr.split("-");

        let h, m;
        if (time instanceof Date) {
          h = time.getHours();
          m = time.getMinutes();
        } else {
          [h, m] = time.split(":").map(Number);
        }

        const hour = String(h).padStart(2, "0");
        const minute = String(m).padStart(2, "0");

        return `${year}-${month}-${day} ${hour}:${minute}:00`;
      };

      const formatTime = (date) =>
        date instanceof Date
          ? `${date.getHours().toString().padStart(2, "0")}:${date
              .getMinutes()
              .toString()
              .padStart(2, "0")}`
          : date || "";

      const datetimeFrom = combineDateTime(editData.DATE, StartTime);
      const datetimeTo = combineDateTime(editData.DATE, EndTime);
      
      const data = {
        ALLOWANCE_MST_ID: editData.ALLOWANCE_MST_ID, //get from allData
        ALLOWANCE_DETAILS_ID: editData.ALLOWANCE_DETAILS_ID,
        USER_MST_GUID: userId,
        UPDATE_ID: userId,
        UPDATE_NAME: userName,
        DAY_TYPE: dayType.key,
        WORK_LOCATION: workLocation.key,
        ALLOWANCE_TYPE: allowanceType.key,
        DATETIME_FROM: datetimeFrom,
        DATETIME_TO: datetimeTo,
        AMOUNT: parseFloat(amount.value).toFixed(2),
        PURPOSE: editData.PURPOSE,
        DETAILS: editData.DETAILS,
        FROM_SOURCE: {SOURCE: "WEB", MODULE_ID: props.module },
      };
      http
        .post("api/allowance/EditAllowanceDetails", data, { timeout: 10000})
        .then((response) => {
          const updatedRow = {
            ...editData,
            DAY_TYPE_ID: dayType.key,
            DAY_TYPE: dayType.label,
            WORK_LOCATION_ID: workLocation.key,
            WORK_LOCATION: workLocation.label,
            ALLOWANCE_TYPE_ID: allowanceType.key,
            ALLOWANCE_TYPE: allowanceType.label,
            START_TIME: formatTime(StartTime),
            END_TIME: formatTime(EndTime),
            AMOUNT: parseFloat(amount.value).toFixed(2),
            TOTAL_HOURS: getTimeDiff(StartTime, EndTime),
            PURPOSE: editData.PURPOSE,
            DETAILS: editData.DETAILS,
          };
          props.onUpdateRow?.(updatedRow);
          toast.success("Allowance details is successfully updated.");
					props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to update allowance details. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
    } catch (err) {
      toast.error("Failed to update allowance details. Please try again.....(receive)");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: `${name} could not be empty.`,
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));

      if (id === "DATE" && val) {
        const selectedDate = new Date(val + "T00:00:00");

        const dayOfWeek = selectedDate.getDay();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

        const isHoliday = holidayList.some(
          (h) => new Date(h.value).toDateString() === selectedDate.toDateString()
        );

        let newDayType = null;

        if (isWeekend || isHoliday) {
          newDayType = dayTypeList.find(
            (dt) => dt.value === "7B396124-52B2-4EB1-9A85-4F294B7911EB"
          );
        } else {
          newDayType = dayTypeList.find(
            (dt) => dt.value === "2A1138EA-1C4D-45A2-BE70-A1F123AC01DF"
          );
        }

        if (newDayType) {
          setDayType({ key: newDayType.key, value: newDayType.value, label: newDayType.label });
        }
        
        setWorkLocation("");
        setAllowanceType("");
        setTimeRange([null, null]);
        setIsFixedTime(false);
      }
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }
    
  const selectDayTypeHandler = (val) => {
    let functionName = "";
    
    try {
      functionName = selectDayTypeHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          DAY_TYPE: "",
          AMOUNT: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          DAY_TYPE: "Day Type could not be empty.",
        }));
      }
      setDayType(val);
      setWorkLocation("");
      setAllowanceType("");
      setTimeRange([null, null]);
      setIsFixedTime(false);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }
    
    const selectWorkLocationHandler = (val) => {
      let functionName = "";
    
      try {
        functionName = selectWorkLocationHandler.name;
        if (val && Object.keys(val).length > 0) {
          setInputError((prevState) => ({
            ...prevState,
            WORK_LOCATION: "",
            AMOUNT: "",
          }));
        } else {
          setInputError((prevState) => ({
            ...prevState,
            WORK_LOCATION: "Work Location could not be empty.",
          }));
        }
        setWorkLocation(val);
        setAllowanceType("");
        setTimeRange([null, null]);
        setIsFixedTime(false);
      } catch (err) {
        common.c_LogWebError(props.page, functionName, err);
      }
      setHasChanges(true);
    }
    
    const selectAllowanceTypeHandler = (val) => {
      let functionName = "";
    
      try {
        functionName = selectAllowanceTypeHandler.name;
        if (val && Object.keys(val).length > 0) {
          setInputError((prevState) => ({
            ...prevState,
            ALLOWANCE_TYPE: "",
            AMOUNT: "",
          }));
        } else {
          setInputError((prevState) => ({
            ...prevState,
            ALLOWANCE_TYPE: "Allowance Type could not be empty.",
          }));
        }
        setAllowanceType(val);
        setTimeRange([null, null]);
        setIsFixedTime(false);
      } catch (err) {
        common.c_LogWebError(props.page, functionName, err);
      }
      setHasChanges(true);
    }
    
    const handleTimeChange = times => {
      const [start, end] = times;
  
      setInputError((prevState) => ({
        ...prevState,
        TIME: (""),
        AMOUNT: "",
      }));
  
      // if (start && end) {
      //   const timeToMinutes = (t) => t.getHours() * 60 + t.getMinutes();

      //   if (timeToMinutes(end) < timeToMinutes(start)) {
      //     setInputError((prev) => ({
      //       ...prev,
      //       TIME: "End time cannot be earlier than start time",
      //     }));
      //     return;
      //   }
      // }
      setTimeRange(times);
      setHasChanges(true);
    }

	//#region Event handle
	const hideModal = () => {
    setEditData(initialEditData);
    setInputError([]);
    setDayType([]);
    setWorkLocation([]);
    setAllowanceType([]);
		setHasChanges(false);
    props.onHide();
  };

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

  const handleConfirm = () => {
		var flag = true;

    if (dayType.length === 0) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				DAY_TYPE: ("Day Type could not be empty."),
			}));
		}

    if (workLocation.length === 0) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				WORK_LOCATION: ("Work Location could not be empty."),
			}));
		}

    if (allowanceType.length === 0) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				ALLOWANCE_TYPE: ("Allowance Type could not be empty."),
			}));
		}

    if (editData.DATE === undefined) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				DATE: ("Date could not be empty."),
			}));
		// } else {
    //   const selectedDate = new Date(editData.DATE);
    //   const day = selectedDate.getDay();
    //   const formattedDate = `${selectedDate.getDate().toString().padStart(2,'0')}/${
    //     (selectedDate.getMonth()+1).toString().padStart(2,'0')}/${
    //     selectedDate.getFullYear()}`;

    //   if (dayType.key === "2A1138EA-1C4D-45A2-BE70-A1F123AC01DF" && (day === 0 || day === 6)) {
    //     flag = false;
    //     setInputError((prevState) => ({
    //       ...prevState,
    //       DATE: (formattedDate + " is not " + dayType.label),
    //     }));
    //   } else if (dayType.key === "7B396124-52B2-4EB1-9A85-4F294B7911EB" && (day !== 0 && day !== 6)) {
    //     flag = false;
    //     setInputError((prevState) => ({
    //       ...prevState,
    //       DATE: (formattedDate + " is not " + dayType.label),
    //     }));
    //   }
    }

    // if (startTime === null || endTime === null) {
    //   flag = false;
		// 	setInputError((prevState) => ({
		// 		...prevState,
		// 		TIME: ("Time could not be empty."),
		// 	}));
		// }

    if (!amount || amount.value == "0") {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				AMOUNT: ("Amount could not be 0."),
			}));
		}

    if (editData.PURPOSE === undefined) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				PURPOSE: ("Purpose could not be empty."),
			}));
		}

    if (editData.DETAILS === undefined) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				DETAILS: ("Details could not be empty."),
			}));
		}
    
    if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
    	setShowConfirmModal(true);
    }
  };

  const handleConfirmModal = () => {
    saveEditDetails();
    setShowConfirmModal(false); // Hide confirm modal
    hideModal();
  };

  const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide back modal on cancel
  };
	//#endregion

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered size="xl">
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Edit</Modal.Title>
          </div>
        </Modal.Header>
    
        <Modal.Body>
          <div style={{ marginBottom: "15px" }}>
            <h5>Allowance Details</h5>
            <hr />
            <div className="allowanceTableWrapper">
              <table className="allowanceTable">
                <tr>
                  <td colSpan="2" style={{ paddingRight: "1rem" }}>
                    <Comp.Input
                      id="DATE"
                      label="Date*"
                      type="date"
                      name="Date"
                      value={editData.DATE || ""}
                      placeholderText="Select date"
                      onChange={inputRequiredHandler}
                      errorMessage={inputError.DATE}
                    />
                  </td>
                  <td colSpan="2" style={{ paddingRight: "1rem" }}>
                    <Comp.Select
                      id="WORK_LOCATION"
                      label="Work Location*"
                      type="text"
                      name="Work Location"
                      options={workLocationList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      value={workLocation}
                      onChange={selectWorkLocationHandler}
                      errorMessage={inputError.WORK_LOCATION}
                      isMulti={false}
                    />
                  </td>
                  <td colSpan="2" style={{ paddingRight: "1rem" }}>
                    <Comp.Select
                      id="ALLOWANCE_TYPE"
                      label="Allowance Type*"
                      type="text"
                      name="Allowance Type"
                      options={allowanceTypeList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      value={allowanceType}
                      onChange={selectAllowanceTypeHandler}
                      errorMessage={inputError.ALLOWANCE_TYPE}
                      isMulti={false}
                    />
                  </td>
                  <td colSpan="2" style={{ paddingRight: "1rem" }}>
                    <Comp.TimeRangePicker
                      id="TIME"
                      label="Time (From - To)"
                      name="Time"
                      value={timeRange}
                      onChange={handleTimeChange}
                      disabled={isFixedTime}
                    />
                  </td>
                  <td colSpan="2" style={{ paddingRight: "1rem" }}>
                    <Comp.Input
                      id="TOTAL_TIME"
                      label="Total Time (hh:mm)"
                      name="Total Time"
                      value={totalHour}
                      readOnly
                    />
                  </td>
                  <td colSpan="2">
                    <Comp.Input
                      id="AMOUNT"
                      label="Amount"
                      type="text"
                      name="Amount"
                      className="form-control-amount"
                      value={`RM ${amount?.value ? amount.value.toFixed(2) : 0}`}
                      errorMessage={inputError.AMOUNT}
                      readOnly
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" style={{ paddingRight: "1rem" }}>
                    <label style={{ padding: "6px" }}>Purpose*</label>
                    <textarea
                      id="PURPOSE"
                      name="Purpose"
                      rows={2}
                      className="form-control-allowance"
                      value={editData.PURPOSE}
                      onChange={inputRequiredHandler}
                      errorMessage={inputError.PURPOSE}
                    />
                    {inputError.PURPOSE && (
                      <div className="text-danger mt-1" style={{ fontSize: "85%"}}>
                        {inputError.PURPOSE}
                      </div>
                    )}
                  </td>
                  <td colSpan="4" style={{ paddingRight: "1rem" }}>
                    <label style={{ padding: "6px" }}>Details*</label>
                    <textarea
                      id="DETAILS"
                      name="Details"
                      rows={2}
                      className="form-control-allowance"
                      value={editData.DETAILS}
                      onChange={inputRequiredHandler}
                      errorMessage={inputError.DETAILS}
                    />
                    {inputError.DETAILS && (
                      <div className="text-danger mt-1" style={{ fontSize: "85%"}}>
                        {inputError.DETAILS}
                      </div>
                    )}
                  </td>
                  <td colSpan="4">
                    <label style={{ padding: "6px" }}>Remark</label>
                    <textarea
                      id="REMARK"
                      name="Remark"
                      rows={2}
                      className="form-control-allowance"
                      value={amount?.label || ""}
                      readOnly
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </Modal.Body>
    
        <Modal.Footer>
          <div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
            </Comp.Button>
                
            <Comp.Button id="btnSave" onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Save
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
        prop="Confirm Navigation"
      >
        Are you sure you want to go back? Your changes may be lost.
      </BackModal>

      <ConfirmModal
        show={showConfirmModal}
        onHide={handleConfirmModalClose}
        onConfirm={handleConfirmModal}
			  prop="Confirm to save"
      >
        Are you sure you want to update allowance details?
      </ConfirmModal>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default AllowanceDetailsUpdate;
